import { Guid } from '@web/utils';
import { WarehouseReceiptStatus } from '../enums/warehouse-receipt-status';

export class WarehouseReceiptCollectionItem {
  public constructor(
    private readonly data: {
      canBeApproved: boolean;
      canBeEdited: boolean;
      canBeViewed: boolean;
      createdAt: Date;
      id: Guid;
      number: string;
      productNames: string[];
      productSkus: string[];
      receiptedAt: Date;
      status: WarehouseReceiptStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): string {
    return this.data.number;
  }

  public get receiptedAt(): Date {
    return this.data.receiptedAt;
  }

  public get productNames(): string[] {
    return this.data.productNames;
  }

  public get productSkus(): string[] {
    return this.data.productSkus;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get status(): WarehouseReceiptStatus {
    return this.data.status;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeApproved(): boolean {
    return this.data.canBeApproved;
  }
}
